/* PSM kinds */ export enum ADDON_KIND {
  RESIDENTIAL_VOICE = 'RESIDENTIAL_VOICE',
  VOICE_ATA = 'VOICE_ATA',
  BUSINESS_VOICE = 'BUSINESS_VOICE',
  BUSINESS_VOICE_L3 = 'BUSINESS_VOICE_L3',
  EASY_CARE = 'EASY_CARE',
  SHIELD = 'SHIELD',
  STATIC_IP = 'STATIC_IP',
  OFFICE_HOURS = 'OFFICE_HOURS',
  CONTENT_ADD_ON = 'CONTENT_ADD_ON',
  CYBER_PROTECT = 'VA_SHIELD',
}

/* OFM kinds */ export const ADDON_PRODUCT_KIND = {
  easyCare: 'bep.ofm.product-types.easy-care',
  shield: 'bep.ofm.package-types.shield',
  staticIp: 'bep.ofm.package-types.static-ip',
  voice: 'bep.ofm.product-types.satellite-internet-add-on',
  officeHours: 'bep.ofm.product-types.office-hours',
  viasatStream: 'bep.ofm.product-types.streamon',
  cyberProtect: 'bep.ofm.package-types.cyberprotect',
} as const;

export const VOICE_ADDONS_KINDS: string[] = [
  ADDON_KIND.RESIDENTIAL_VOICE,
  ADDON_KIND.VOICE_ATA,
  ADDON_KIND.BUSINESS_VOICE,
  ADDON_KIND.BUSINESS_VOICE_L3,
];

export enum ADD_ON_STATE {
  INCLUDED = 'Included',
  SUBSCRIBED = 'Subscribed',
  PENDING = 'Pending deactivation',
}

export enum EasyCareProducts {
  DEFAULT = 'EasyCare',
  PLUS = 'EasyCare+',
  PREMIUM = 'EasyCare Premium',
}
